import React from 'react';

const VEITLogo = ({ className = '', light = false }) => (
  <div className={`flex items-center ${className}`}>
    <div className={`flex items-center justify-center py-1.5 px-3 rounded-lg bg-white ${light ? 'shadow-lg shadow-black/20' : 'shadow-sm border border-veit-border'}`}>
      <img 
        src="https://media-manager-c.questera.ai/greta-media/ecb16a7902f793d76e4d541ba9ce1c3ae6d96976df461599e59c7024cc2713617bff44ec4f8cbf96d32b4bb87bd2d993/images/aW1hZ2UvcG5n/597124fe5cc07e15088308867fda95bd.png" 
        alt="Visual Edge IT" 
        className="h-7 sm:h-9 object-contain"
      />
    </div>
    
    <div className="ml-3 pl-3 border-l-2 border-slate-500/30 flex flex-col justify-center">
      <div className={`text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase ${light ? 'text-white' : 'text-veit-navy'}`}>
        vCISO Practice
      </div>
    </div>
  </div>
);

export default VEITLogo;